export default __webpack_public_path__ + "static/media/ambulance.02b1e92e.jpg";